import { ValueBottomAxis } from '../../../core/components/axes/components/ValueBottomAxis.js';
import { ValueLeftAxis } from '../../../core/components/axes/components/ValueLeftAxis.js';
import { ChartGrid } from '../../../core/components/chart-grid/ChartGridRoot.js';
import { useCategoricalBarChartBaseConfig } from '../../hooks/useCategoricalBarChartBaseConfig.js';
import { useCategoricalBarChartScales } from '../../hooks/useCategoricalBarChartScales.js';
import { useCategoricalBarChartTicks } from '../../hooks/useCategoricalBarChartTicks.js';
import { useCategoricalBarChartValueAxisConfig } from '../../hooks/useCategoricalBarChartValueAxisConfig.js';
import { AREAS } from '../../types/categorical-bar-area-rules.js';
import { isVertical } from '../../utils/layout.js';

export const CategoricalBarChartValueAxis = () => {
  const { valueScale } = useCategoricalBarChartScales();
  const { label: valueAxisLabel } = useCategoricalBarChartValueAxisConfig();
  const { layout } = useCategoricalBarChartBaseConfig();
  const { valueAxis } = useCategoricalBarChartTicks();

  return isVertical(layout) ? (
    <ChartGrid.GridArea gridArea={AREAS.leftAxis}>
      {({ availableWidth, availableHeight }) => (
        <ValueLeftAxis
          formattedTicks={valueAxis.formattedTicks}
          ticks={valueAxis.ticks}
          containerHeight={availableHeight}
          containerWidth={availableWidth}
          scale={valueScale}
          label={valueAxisLabel}
        />
      )}
    </ChartGrid.GridArea>
  ) : (
    <ChartGrid.GridArea gridArea={AREAS.bottomAxis}>
      {({ availableWidth, availableHeight }) => (
        <ValueBottomAxis
          formattedTicks={valueAxis.formattedTicks}
          ticks={valueAxis.ticks}
          containerHeight={availableHeight}
          containerWidth={availableWidth}
          scale={valueScale}
          label={valueAxisLabel}
        />
      )}
    </ChartGrid.GridArea>
  );
};

CategoricalBarChartValueAxis['displayName'] = 'CategoricalBarChartValueAxis';
